import { jwtDecode } from 'jwt-decode';

export function shouldRenewToken(
  token: string | null,
  renewBeforeMinutes: number = 90
): boolean {
  if (!token) return true;

  try {
    const decoded = jwtDecode<{ exp?: number }>(token);

    if (!decoded.exp) return true;

    const currentTime = Math.floor(Date.now() / 1000);
    const renewThreshold = renewBeforeMinutes * 60;

    return decoded.exp - currentTime <= renewThreshold;
  } catch (error) {
    console.error('Error decoding JWT token:', error);
    return true;
  }
}

export function isTokenExpired(token: string | null): boolean {
  return shouldRenewToken(token, 0);
}

export function getTokenExpirationInfo(token: string | null): string {
  if (!token) return 'Token not found';

  try {
    const decoded = jwtDecode<{ exp?: number }>(token);

    if (!decoded.exp) return 'Token without expiration date';

    const currentTime = Math.floor(Date.now() / 1000);
    const timeLeft = decoded.exp - currentTime;

    if (timeLeft <= 0) {
      return 'Token already expired';
    }

    const hoursLeft = Math.floor(timeLeft / 3600);
    const minutesLeft = Math.floor((timeLeft % 3600) / 60);

    return `Token expires in ${hoursLeft}h ${minutesLeft}m`;
  } catch (error) {
    return 'Error decoding token';
  }
}
